







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Argurments from '@/components/extrinsics/Arguments.vue';
import referendumState from './referendumState';
import Connector from '@vue-polkadot/vue-api';
import Vote from '@/components/shared/modals/Vote.vue';
import Money from '@/components/shared/format/Money.vue'

@Component({
  components: {
    Argurments,
    Vote,
    Money
  },
})
export default class Referendum extends Vue {
  @Prop() public referendum: any;

	private shouldRender: boolean = true;
  private isArgsVisible: boolean = false;
	private state: any = {};
	private bestNumber: any = {};
	private enactBlock: any = {};
	private remaining: any = {};

	public async mounted() {
		this.state = await referendumState(this.referendum);
		this.bestNumber = await Connector.getInstance().api.derive.chain.bestNumber();
		this.enactBlock = this.referendum.status.end.add(this.referendum.status.delay);
		this.remaining = this.referendum.status.end.sub(this.bestNumber).subn(1);

		if (!this.bestNumber || this.referendum.status.end.sub(this.bestNumber).lten(0)) {
    	this.shouldRender = false;
  	}
	}

  public toggleArgsVisible() {
    this.isArgsVisible = !this.isArgsVisible;
  }

  public handleSelectedArguments() {
    return;
  }

  public enhanceArgs() {
    return this.referendum.proposal.meta.args;
  }

}
